import React from 'react';
import DemoLessonPlanDetail from '../demo/DemoLessonPlanDetail';

const StandardLessonPlanDetail = ({ user, onLogout }) => {
  return <DemoLessonPlanDetail user={user} onLogout={onLogout} isDemoMode={false} />;
};

export default StandardLessonPlanDetail;
